<!----------------------- Компонент договору про обробку персональних даних (DPA) --------------------->
<template>
    <div class="container">
        <div class="header">
            <a href="/" class="dpa-logo">
                <headloginreg />
            </a>
            <SelectLangs @changeLang="changeLang($event)" :utilityLang="currentLang" :limited="language" />
        </div>
        <div class="special">
            <div class="currentSpan" @click="goLogin">
                <svg class="go-login-icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15"
                    viewBox="0 0 451.847 451.847">
                    <path fill="#000" d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
    c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
    c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z" />
                </svg>
                <span class="go-login2">{{ currentLang === 'ru' ? currentSpan.descRU :
                    currentLang === 'uk' ? currentSpan.descUK : currentSpan.descEN }}</span>
            </div>
        </div>
        <hr>
        <DPARu v-if="currentLang === 'ru'" :key="currentLang" />
        <DPAUk v-if="currentLang === 'uk'" :key="currentLang" />
        <DPAEn v-if="currentLang === 'en'" :key="currentLang" />
    </div>
</template>

<script>
import { store } from "@/store.js";
import SelectLangs from '../LangSelectComponent.vue';
import headloginreg from "../heads/HeaderLoginAndReg.vue"
import DPARu from "./DPAContent/DPARu.vue"
import DPAUk from "./DPAContent/DPAUk.vue"
import DPAEn from "./DPAContent/DPAEn.vue"
export default {
    components: {
        headloginreg,
        SelectLangs,
        DPARu,
        DPAUk,
        DPAEn
    },
    data() {
        return {
            currentLang: "",
            language: [
                { name: "uk", text: "UA", description: "Українська" },
                { name: "en", text: "EN", description: "English" },
                { name: "ru", text: "RU", description: "Русский" }
            ],
            currentSpan: {
                descUK: 'Авторизація',
                descRU: 'Авторизация',
                descEN: 'Authorization'
            }
        }
    },
    created() {
        switch (store.lang) {
            case "ru":
            case "uk":
            case "en":
                this.currentLang = store.lang;
                break;
            default:
                this.currentLang = 'en';
                break;
        }
    },
    methods: {
        changeLang(l) {
            localStorage.setItem("lang_user", l);
            store.lang = l;
            window.lang = store.langs[store.lang]();
            this.currentLang = l
        },
        goLogin() {
            this.$router.push("/");
        },
    },
};
</script>

<style scoped>
.container {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 20px;
    padding-right: 20px;
}

.header {
    margin-bottom: 40px;
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
}

.currentSpan {
    cursor: pointer;
    color: black;
    display: flex;
    align-items: center;
    gap: 5px;
}

.go-login-icon {
    transform: rotate(90deg);
}

.go-login {
    font-size: 15px;
}

.custom-select {
    cursor: pointer;
}

.special {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 35px;
}

body {
    overflow: scroll;
}

@media (max-width: 411px) {
    h1 {
        font-size: 30px;
    }
}

/*Только айфон Xr, 11, 11pro Max, Xs Max*/
@media only screen and
(device-width : 375px) and (device-height : 812px) and (-webkit-device-pixel-ratio : 3),
(device-width : 414px) and (device-height : 896px) and (-webkit-device-pixel-ratio : 3),
(device-width : 414px) and (device-height : 896px) and (-webkit-device-pixel-ratio : 2),
(device-width : 428px) and (device-height : 926px) and (-webkit-device-pixel-ratio : 3),
(device-width : 390px) and (device-height : 844px) and (-webkit-device-pixel-ratio : 3),
(device-width : 393px) and (device-height : 852px) and (-webkit-device-pixel-ratio : 3), /*14 pro 15 15 pro 16*/
(device-width : 430px) and (device-height : 932px) and (-webkit-device-pixel-ratio : 3), /*14 pro max 15 pro max 15 plus 16 plus*/
(device-width : 402px) and (device-height : 874px) and (-webkit-device-pixel-ratio : 3), /*16 pro, 17, 17 pro, 18 pro*/
(device-width : 440px) and (device-height : 956px) and (-webkit-device-pixel-ratio : 3), /*16 pro max, 17 pro max, 18 pro max*/
(device-width : 420px) and (device-height : 912px) and (-webkit-device-pixel-ratio : 3) /*Air*/
{
    @media screen and (orientation: portrait) {
        .container {
            padding-top:calc(env(safe-area-inset-top) + 15px) !important;
        }
    }
    @media screen and (orientation: landscape) {

    }
}
</style>
